import { ObligationTypeEnum } from "@app/ps/enums/obligation-type.enum";
import { ProjectSubjectModel } from "@app/ps/models/project-subject.model";

// uživatel z LPIS, nabízený jako pachtýř, při výběru se z něj vytvoří pachtýř (subjekt projektu s diskriminantem E)
export interface LpisLesseeModel {
  id: number;
  obchodniJmeno?: string;
  jmeno?: string;
  prijmeni?: string;
  titulPredJmenem?: string;
  titulZaJmenem?: string;
  ico?: string;
  ulice?: string;
  cisloPopisne?: string;
  cisloOrientacni?: string;
  castObce?: string;
  mestskaCast?: string;
  obec?: string;
  psc?: string;
}

export const LESSEE_OBLIGATION_TYPES = [
  ObligationTypeEnum.RentalContractCommonLiability.toString(),
  ObligationTypeEnum.RentalContractShorterThan1YearLiability.toString(),
  ObligationTypeEnum.RentalContractLongerThan1YearLiability.toString()
];

export const isLesseeObligationType = (obligationType: string): boolean => {
  return LESSEE_OBLIGATION_TYPES.includes(obligationType);
};

// aktuální výběr pachtýře ve formuláři: už založený pachtýř nebo uživatel z LPIS, ze kterého se pachtýř teprve založí
export interface LesseeSelection {
  lessee?: ProjectSubjectModel;
  lpis?: LpisLesseeModel;
}

// položka výběru: už existující pachtýř nebo uživatel z LPIS, ze kterého se pachtýř teprve založí
export interface LesseeOption {
  id: string;
  lessee?: ProjectSubjectModel;
  lpis?: LpisLesseeModel;
}
